const MAX_EMAIL_LENGTH = 64;
export const validateEmail = (value) => {
    if (!value || value.length > MAX_EMAIL_LENGTH) {
        return false;
    }

    const regex =
        /^[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?(?:\.[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?)*(?:\.[A-Za-z]{2,})$/;

    return regex.test(value);
};
